import BaseHttp from './BaseHttp';
import config from '../../config/app.config';
class OdooSyncAPI extends BaseHttp {
    constructor(config) {
        super();
        Object.defineProperty(this, "config", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
        Object.defineProperty(this, "getRequestedCarsCount", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                return this.privateRequest('get', 'leads/count?wonStatus=pending');
            }
        });
        Object.defineProperty(this, "getRequestedCars", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                return this.privateRequest('get', 'leads');
            }
        });
        Object.defineProperty(this, "getPendingRequestedCars", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                return this.privateRequest('get', 'leads?wonStatus=pending');
            }
        });
        Object.defineProperty(this, "getWonCars", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                return this.privateRequest('get', 'leads?wonStatus=won');
            }
        });
        this.setConfig(config);
    }
}
export default new OdooSyncAPI({
    baseURL: config.odooSyncAPI.url
});
